import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { Alert, Box, Button, Container, Typography } from '@mui/material';
import { useAuth } from '../context/AuthContext';

/**
 * Routewrapper voor het administrator-gedeelte (/admin).
 * Niet ingelogd -> naar login. Wel ingelogd maar geen globale administrator ->
 * een uitleg in plaats van een lege pagina, zodat duidelijk is waarom er niets komt.
 */
function RequireGlobalAdmin({ children }) {
    const { user, isGlobalAdmin } = useAuth();
    const location = useLocation();

    if (!user) {
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    if (!isGlobalAdmin) {
        return (
            <Container maxWidth="sm" sx={{ pt: 8 }}>
                <Alert severity="warning" sx={{ mb: 2 }}>
                    Deze pagina is alleen toegankelijk voor administrators van het spel.
                </Alert>
                <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
                    Beheer je een eigen veiling? Dat doe je vanuit die veiling zelf, niet hier.
                </Typography>
                <Box>
                    <Button variant="contained" href="/my-auctions">
                        Naar mijn veilingen
                    </Button>
                </Box>
            </Container>
        );
    }

    return children;
}

export default RequireGlobalAdmin;
